module.exports = __webpack_public_path__ + "static/media/TELoginLogo.714bfb5f.png";